"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypeUpdate = void 0;
class EventTypeUpdate {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EventTypeUpdate.attributeTypeMap;
    }
}
exports.EventTypeUpdate = EventTypeUpdate;
EventTypeUpdate.discriminator = undefined;
EventTypeUpdate.attributeTypeMap = [
    {
        "name": "archived",
        "baseName": "archived",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string",
        "format": ""
    },
    {
        "name": "featureFlag",
        "baseName": "featureFlag",
        "type": "string",
        "format": ""
    },
    {
        "name": "schemas",
        "baseName": "schemas",
        "type": "{ [key: string]: any; }",
        "format": ""
    }
];
//# sourceMappingURL=EventTypeUpdate.js.map